<template>
  <div>
    <div v-if="!laoding && warehouse_stock.length > 0" class="container span12">
      <div v-for="(item, index) in warehouse_stock" :key="index">
        <label class="warehouse">{{ item.warehouse.name }}</label>
        <div class="tab">
          <div v-for="(lot, index2) in item.lots" :key="index2" class="flex">
            <input
              type="radio"
              name="guest_protection[warehouse_id_lot_id]"
              :value="getValue(item.warehouse.id, lot.id)"
              :checked="index == 0 ? true : false"
            />
            <label>Quantità: {{ lot.qta_left }}</label>
            <label>Lotto: {{ lot.name || 'nessun lotto' }} ({{ conv(lot) }})</label>
            <label>{{ lot.expiration_date | moment }}</label>
          </div>
        </div>
      </div>
    </div>
    <div v-else>Nessuna giacenza disponibile</div>
    <spinner :visible="laoding"></spinner>
  </div>
</template>
<script>
import { warehouseApiConnector } from '../../starApiConnector';
import { Route } from '../../route';
import spinner from '../spinner';
import { WarehouseConstants } from '../../warehouse_constants';

export default {
  name: 'choose-warehouse-item',
  components: {
    spinner,
  },
  props: ['itemId', 'datein', 'dateout'],
  data() {
    return {
      laoding: false,
      warehouse_stock: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  filters: {
    moment(date) {
      const d = moment(date);
      return d.isValid() ? moment(date).format('DD/MM/YYYY') : null;
    },
  },
  mounted() {
    // chiamata a warehouse per avere i warehouse items endpoit: warehouse_items_by_item_id /items/1/warehouse_items/index
    // quando ritorna la risposta faccio una tabellina che fa selezionare il magazzino voluto, per ogni magazzino devo visualizzare i lotti disponibili
    this.getWarehouseStock();
  },
  watch: {
    itemId: function (newVal, oldVal) {
      // watch it
      this.getWarehouseStock();
    },
    datein: function (newVal, oldVal) {
      this.getWarehouseStock();
    },
    dateout: function (newVal, oldVal) {
      this.getWarehouseStock();
    },
  },
  methods: {
    getValue(warehouse_id, lot_id) {
      return JSON.stringify({ warehuose_id: warehouse_id, lot_id: lot_id });
    },
    getWarehouseStock() {
      this.laoding = true;
      const params = {
        from: this.getDatein(),
        to: this.getDateout(),
      };
      warehouseApiConnector()
        .get(`items/${this.itemId}/warehouse_items/warehouse_items_available?exclude_kinds[]=${WarehouseConstants.WAREHOUSE_TYPE_GUEST}`, {
          params: params,
        })
        .then((response) => {
          this.warehouse_stock = response.data;
          this.laoding = false;
        })
        .catch((error) => {
          console.log('error ' + error);
          this.laoding = false;
        });
    },
    getDatein() {
      const date = moment(this.datein, i18nJS.time.formats.date_only);
      return date.isValid() ? date.format('L') : null;
    },
    getDateout() {
      const date = moment(this.dateout, i18nJS.time.formats.date_only);
      return date.isValid() ? date.format('L') : null;
    },
    conv(lot) {
      return lot.conv ? 'convenzionato' : 'non convenzionato';
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 6px;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #d00;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border-radius: 4px;
}
.flex {
  display: flex;
}
.warehouse {
  color: #767676;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  &:not(:first-child) {
    margin-top: 6px;
  }
}
label {
  margin-left: 5px;
}
.tab {
  margin-left: 24px;
}
</style>
